import React from 'react';
import GoBookNowLogo from './GoBookNowLogo';

const RoleSelectionScreen = ({ onSelectRole }) => {
  return (
    <div className="fixed inset-0 bg-black flex items-center justify-center z-50 p-4" 
         style={{
           backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.7)), url("/images/manhattan-evening.png")',
           backgroundSize: 'cover',
           backgroundPosition: 'center'
         }}>
      <div className="bg-white rounded-lg shadow-2xl overflow-hidden max-w-md w-full">
        <div className="bg-linear-to-r from-blue-600 to-indigo-800 p-6">
          <h2 className="text-white text-2xl font-bold">Select Your Role</h2>
          <p className="text-blue-100 mt-2">Choose which experience you'd like to explore</p>
        </div>
        
        <div className="p-6">
          <div className="flex justify-center mb-6">
            <GoBookNowLogo height="100" />
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-6">
            <button
              onClick={() => onSelectRole('customer')}
              className="bg-blue-50 hover:bg-blue-100 border-2 border-blue-200 rounded-lg p-6 transition duration-150 flex flex-col items-center"
            >
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mb-3">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-blue-800">Customer</h3>
              <p className="text-sm text-gray-600 text-center mt-2">
                Browse and book travel experiences
              </p>
            </button>
            
            <button
              onClick={() => onSelectRole('support')}
              className="bg-indigo-50 hover:bg-indigo-100 border-2 border-indigo-200 rounded-lg p-6 transition duration-150 flex flex-col items-center"
            >
              <div className="w-16 h-16 bg-indigo-600 rounded-full flex items-center justify-center mb-3">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192l-3.536 3.536M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z" />
                </svg>
              </div>
              <h3 className="text-lg font-semibold text-indigo-800">Support Agent</h3>
              <p className="text-sm text-gray-600 text-center mt-2">
                Manage customer support requests
              </p>
            </button>
          </div>
        </div>
        
        <div className="bg-gray-50 px-6 py-4 border-t">
          <div className="flex flex-col items-center">
            <p className="text-sm text-gray-600 text-center mb-2">
              Select the experience you'd like to explore.
            </p>
            <p className="text-xs text-gray-500 text-center mb-3">
              You can switch between roles using the role selector in the header.
            </p>
            <button 
              onClick={() => {
                sessionStorage.removeItem('authenticated');
                window.location.reload();
              }}
              className="text-sm text-blue-600 hover:text-blue-800 transition duration-150"
            >
              Back to Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RoleSelectionScreen;